import {BieLoaderModal} from 'basic-image-editor/src/BieLoader';

import {Loadable} from 'app/components/general/lazyLoader';

import type {Props} from './ImageEditorLoader';
import './ImageEditorLoader';
export const LoadableImageEditor = Loadable<Error, Props>({
  loader: () =>
    import(
      /* webpackChunkName: "image-editor" */
      './ImageEditorLoader'
    ),
  LoadingComponent: BieLoaderModal,
});
export const convertToBlob = (data_URL: string) => {
  const [mimeStr, dataStr] = data_URL.split(',');
  const match = mimeStr.match(/:(.+);/);
  let type = 'image/png';

  if (match != null) {
    type = match[1];
  }

  const binary = atob(dataStr);
  const array: Array<number> = [];

  for (let i = 0; i < binary.length; i++) {
    array.push(binary.charCodeAt(i));
  }

  return new Blob([new Uint8Array(array)], {
    type,
  });
};
